<template>
  <section class="contact-area pb-90">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="contact-box">
            <h3 class="title">基本资料</h3>
            
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item label="姓名" prop="realname">
                <el-input v-model="ruleForm.realname"></el-input>
              </el-form-item>

              <el-form-item label="公司" prop="company">
                <el-input v-model="ruleForm.company"></el-input>
              </el-form-item>

              <el-form-item label="职务" prop="position">
                <el-input v-model="ruleForm.position"></el-input>
              </el-form-item>

              <el-form-item label="邮箱" prop="email">
                <!-- 使用flex容器排列输入框和按钮 -->
                <div style="display: flex; gap: 10px; align-items: center;">
                  <el-input 
                    v-model="ruleForm.email" 
                    placeholder="请输入邮箱"
                    style="width: 85%;"
                  ></el-input>
                  
                  <template v-if="!mailing">
                    <el-button 
                      type="primary"  
                      style="width: 15%;"
                      icon="el-icon-plus"
                      @click="subscribeEmail"
                    >订阅</el-button>
                  </template>

                  <template v-else>
                    <el-button 
                      type="success"  
                      style="width: 15%;"
                      icon="el-icon-check"
                    >已订阅</el-button>
                  </template>

                </div>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { putProfile } from '@/api/user';
import { 
  getMailings,
  postMailing 
} from '@/api/mailing';

export default {
  props: {
    profile: {
      type: Object,
      default: () => ({}) // 接收父组件传递的 profile 数据
    },
    defaultEmail: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      ruleForm: {
        realname: '', // 姓名
        company: '',  // 公司
        position: '', // 职务（修复原代码中的 typo：将 title 改为 position，与表单字段一致）
        email: this.defaultEmail || this.profile?.email || '',  
        summary: ''
      },
      rules: {
        realname: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, message: '请输入姓名', trigger: 'blur' }
        ],
        email: [
          { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: '请输入正确的邮箱格式', trigger: 'blur' }
        ]
      },
      mailing: null
    }
  },
  created() {},
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          putProfile(this.ruleForm).then((res) => {
            if (res.code === 200) {
              this.$message({ message: '更新成功', type: 'success' });
              // 修复：仅在当前路由不是 Profile 时才跳转
              if (this.$route.name !== 'Profile') { 
                this.$router.push({ name: 'Profile' });
              }
              this.$emit('refreshProfile');
            } else {
              this.$message({
                message: res.err || '更新失败',
                type: 'error'
              });
            }
          });

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    setFormDefaults(profileData) {
      if (profileData) {
        this.ruleForm = {
          realname: profileData.realname || '',
          company: profileData.company || '',
          position: profileData.position || '', // 职务字段对应 profile.position
          email: this.defaultEmail || profileData.email || '',
          summary: profileData.summary || ''
        };
      }
    },
    subscribeEmail() {
      postMailing({
        email: this.ruleForm.email,
        name: this.ruleForm.realname
      }).then((res) => {
        if (res.code === 201) {
          this.$message({ message: '订阅成功', type: 'success' });
        } else {
          this.$message({
            message: res.err || '订阅失败',
            type: 'error'
          });
        }
      });
    },
    // 添加新方法封装邮件查询逻辑
    getMailingsData(email) {
      getMailings({
        filter: {
          email: email 
        }
      }).then((res) => {
        if (res.code === 200) {
          const list = res.data.list;
          const item = list.find((item) => item.email === email);
          if (item) {
            this.mailing = item;
            console.log('mailing:', this.mailing);
          }
        }
      });
    },
  },
  watch: {
    // 监听 profile 变化，实时更新表单默认值
    profile: {
      handler(newProfile) {
        this.setFormDefaults(newProfile);
        // const email = newProfile?.email || this.defaultEmail || '';
      },
      immediate: true // 初始化时立即执行
    },
    // 监听 defaultEmail 变化，实时更新表单默认值
    defaultEmail: {
      handler(newEmail) {
        this.ruleForm.email = newEmail || '';
      },
      immediate: true // 初始化时立即执行
    },
    // 添加对email变化的监听，确保数据就绪后查询
    'ruleForm.email': {
      handler(newEmail) {
        if (newEmail) { // 确保邮箱不为空时才查询
          this.getMailingsData(newEmail);
        }
      },
      immediate: true // 初始化时立即执行一次
    }
  }
};
</script>

<style></style>
